import { render, staticRenderFns } from "./ListMateriais.vue?vue&type=template&id=6ca26380&"
import script from "./ListMateriais.vue?vue&type=script&lang=js&"
export * from "./ListMateriais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports